import CheckIcon from "@mui/icons-material/Check";
import RefreshIcon from "@mui/icons-material/Refresh";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React from "react";
import { v4 as uuid } from "uuid";
import ActionModal from "../../detail/actionCopmonets.tsx/actionModal";

interface Props {
  showInstallmentComponent?: boolean;
  printedData?: any;
  showActionBtns?: boolean;
  dataGetCartableActions: any;
  isActionModalBtnDisable: boolean;
  flagActionTabs: any;
  setReload: any;
  getCartableAction: any;
  setDataGetCoreInformation: any;
  referenceKey: any;
  setActionModalBtnDisable: any;
  setShowActionBtns: any;
  setDataGetCartableActions: any;
  setActionTabData: any;
  setFlagActionTab: any;
}

const SaleDetailActionsHeader = ({
  getCartableAction,
  isActionModalBtnDisable,
  flagActionTabs,
  dataGetCartableActions,
  showActionBtns,
  printedData,
  showInstallmentComponent,
  referenceKey,
  setDataGetCoreInformation,
  setReload,
  setActionModalBtnDisable,
  setDataGetCartableActions,
  setShowActionBtns,
  setActionTabData,
  setFlagActionTab,
}: Props) => {
  const actionHandle = (button: any) => {
    setActionTabData(button);
    setFlagActionTab(true);
  };

  return (
    <div>
      <Box
        sx={{
          marginRight: "1.9vh",
          marginLeft: "1.9vh",
          direction: "rtl",
          overflowX: "none",
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={4}
            className="centerVertical"
            style={{ margin: "1vh 0" }}
          >
            {/* {props.printedData ? (
            <Tooltip title="پرونده" arrow>
              <FolderOpenIcon
                // onClick={() => window.print()}
                onClick={openModalPrint}
                className="colorTitle iconStyle cursorPointer"
              />
            </Tooltip>
          ) : null} */}

            {showInstallmentComponent && (
              <>
                <span
                  style={{
                    marginRight: "2vh",
                    marginLeft: "2vh",
                    color: "#CFD8DC",
                  }}
                >
                  |
                </span>
                <Tooltip title="خروجی اکسل" arrow>
                  <img
                    onClick={() => {}}
                    className="cursorPointer"
                    style={{
                      width: "24px",
                      height: "24px",
                      marginBottom: ".5vh",
                    }}
                    src="images/ExportXLS.svg"
                    alt=""
                  />
                </Tooltip>
              </>
            )}
            <>
              {" "}
              {printedData ? (
                <span
                  style={{
                    marginRight: "2vh",
                    marginLeft: "2vh",
                    color: "#CFD8DC",
                  }}
                >
                  |
                </span>
              ) : null}
              <Tooltip title="بروزرسانی" arrow>
                <RefreshIcon
                  onClick={() => setReload(uuid())}
                  className="colorTitle iconStyle cursorPointer"
                />
              </Tooltip>{" "}
            </>
          </Grid>

          {showActionBtns && (
            <Grid item xs={8} className="actionButtonHeader">
              <div className="row ">
                {dataGetCartableActions?.map((button: any) => (
                  <div
                    className={`${
                      button.workflowStepType === "Forward"
                        ? "Success"
                        : "DangerDefaultFont"
                    } p-4 cursorPointer ${
                      flagActionTabs ? "disableForm SecondaryDisableFont" : ""
                    }`}
                  >
                    {!showInstallmentComponent && (
                      <Typography
                        className={
                          isActionModalBtnDisable ? "SecondaryDisableFont" : ""
                        }
                      >
                        {button.showAsModal ? (
                          <ActionModal
                            title={button.action}
                            description={button.description}
                            buttonData={button}
                            icon={
                              button.workflowStepType.toLowerCase() ===
                              "forward" ? (
                                <CheckIcon />
                              ) : (
                                <RestartAltIcon />
                              )
                            }
                            referenceKey={referenceKey}
                            setDataGetCoreInformation={
                              setDataGetCoreInformation
                            }
                            setDataGetCartableActions={
                              setDataGetCartableActions
                            }
                            getCartableAction={getCartableAction}
                            setReload={setReload}
                            setShowActionBtns={setShowActionBtns}
                            setActionModalBtnDisable={setActionModalBtnDisable}
                          />
                        ) : (
                          <span onClick={() => actionHandle(button)}>
                            {button.action}
                          </span>
                        )}
                        {button.workflowStepType.toLowerCase() === "backward" &&
                        !button.showAsModal ? (
                          <RestartAltIcon />
                        ) : button.workflowStepType.toLowerCase() ===
                            "forward" && !button.showAsModal ? (
                          <CheckIcon />
                        ) : null}
                      </Typography>
                    )}
                  </div>
                ))}
              </div>
            </Grid>
          )}
          {/* <Grid item xs={1}>
            {
              <>
                <span
                  style={{
                    color: "#1D4A87",
                    float: "left",
                    marginLeft: "10px",
                    margin: "1vh 0px",
                  }}
                  className="cursorPointer"
                  onClick={() => history.goBack()}
                >
                  بازگشت
                  <ArrowBackIosIcon style={{ width: "12px" }} />
                </span>
              </>
            }
          </Grid> */}
        </Grid>
        {/* <ModalPrint
          openModel={openValidationModel}
          setOpenValidationModel={setOpenValidationModel}
          printedData={printedArray}
          id={props.referenceKey}
        /> */}
        {/* </div> */}
      </Box>
    </div>
  );
};

export default SaleDetailActionsHeader;
